import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCustomize = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M23.0951 12.4751C15.3542 12.4751 10.599 12.7307 10.5998 24.1621C10.6004 32.3361 10.6 39.2669 10.5998 44.1357C10.5997 46.2283 10.5996 47.9399 10.5996 49.2057C10.5996 51.7101 11.2179 57.5536 19.9042 57.5536C26.3059 58.2214 36.9498 57.8319 42.9959 57.5536H47.0272C55.6291 57.5536 55.5917 52.1939 55.5731 49.5407C55.5723 49.4235 55.5715 49.3116 55.5715 49.2057C55.5716 47.9335 55.5715 46.2108 55.5714 44.1036C55.5711 39.2365 55.5708 32.3181 55.5714 24.1621C55.5721 12.7307 48.5768 12.4751 44.309 12.4751H40.8817H23.0951ZM21.5731 17.6868C20.6801 19.2336 21.231 21.2234 22.8035 22.1313C24.3761 23.0392 26.3748 22.5214 27.2678 20.9746C28.1608 19.4279 27.7605 17.3091 26.188 16.4012C24.6155 15.4933 22.4661 16.1401 21.5731 17.6868ZM32.2515 30.0518C31.3567 31.6018 31.9087 33.5959 33.4845 34.5057C35.0604 35.4155 37.0633 34.8965 37.9581 33.3465C38.853 31.7966 38.301 29.8025 36.7252 28.8927C35.1493 27.9829 33.1464 28.5019 32.2515 30.0518ZM28.5154 47.3115C30.0912 46.4017 30.6432 44.4077 29.7484 42.8577C28.8535 41.3077 26.8506 40.7888 25.2747 41.6986C23.6989 42.6084 23.1469 44.6024 24.0418 46.1524C24.9366 47.7024 26.9396 48.2214 28.5154 47.3115Z",
			fill: "#E2E2E4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.425 20.6998C8.42422 9.07874 13.2583 8.81885 21.1277 8.81885H39.2094H42.6935C47.0321 8.81885 54.1435 9.07874 54.1427 20.6998C54.1419 32.5807 54.143 41.8782 54.1429 46.1589C54.1429 48.7048 54.5876 54.6453 45.4568 54.6453H41.3586C35.2122 54.9282 24.3917 55.3242 17.8838 54.6453C9.05333 54.6453 8.42484 48.7048 8.4248 46.1589C8.42476 41.8782 8.4258 32.5807 8.425 20.6998Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6484 31.4854C19.8604 31.2271 23.0513 31.4854 26.2359 31.4854C29.7489 31.4854 27.8514 31.7438 30.3236 31.4854",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.4619 31.4858C39.4619 31.4858 42.0507 31.4858 42.6433 31.4858C43.2969 31.4858 44.0133 31.4858 44.9223 31.4858",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 35.1046,
			cy: 31.6995,
			rx: 3.90908,
			ry: 3.9743,
			transform: "rotate(120 35.1046 31.6995)",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.001 19.1187H19.821",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.001 44.4067H21.9325",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.4492 19.3628C28.4492 19.3628 35.8225 19.3628 36.3852 19.3628C37.0059 19.3628 44.4853 19.378 44.9221 19.1196",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.7559 44.4019C31.7559 44.4019 34.0209 44.4015 37.3133 44.4015C40.6056 44.4015 44.4814 44.1546 44.9216 44.4019",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5238 22.6163C20.6869 21.5558 20.0435 19.2315 21.0866 17.4248C22.1297 15.618 24.6403 14.8625 26.4772 15.923C28.314 16.9835 28.7815 19.4585 27.7384 21.2652C26.6953 23.0719 24.3606 23.6768 22.5238 22.6163Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			rx: 3.97306,
			ry: 4.03934,
			transform: "matrix(0.5 0.866025 0.866025 -0.5 26.8949 44.5051)",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCustomize;
